const TEST_CASE_DEFAULT = {
  initVar: {
    isActive: false,
    vars: [],
  },
  varName: {
    isActive: false,
    vars: [],
  },
  varValue: {
    isActive: false,
    vars: [],
  },
  varType: {
    isActive: false,
    vars: [],
  },
  graph: {
    isActive: false,
    labels: {
      isActive: false,
      xLabel: {
        value: '',
        score: 0,
      },
      yLabel: {
        value: '',
        score: 0,
      },
      title: {
        value: '',
        score: 0,
      },
    },

    legends: {
      isActive: false,
      legs: [],
    },

    line: {
      isActive: false,
      lines: [],
    },

    limit: {
      isActive: false,
      xLim: {
        value: '',
        score: 0,
      },
      yLim: {
        value: '',
        score: 0,
      },
    },

    scale: {
      isActive: false,
      xScale: {
        value: '',
        score: 0,
      },
      yScale: {
        value: '',
        score: 0,
      },
    },
  },
}

export {
  TEST_CASE_DEFAULT,
}
